import moment from 'moment';
import {
  GET_HISTORY_REQUEST,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAILURE,
  GET_HISTORY_CACHED,
  SET_USER_IMPERSONATION,
} from '../action/actionTypes';

const initialState = {
  payload: {},
  isWaiting: false,
  error: null,
  lastRefresh: null,
};

export default function history(state = initialState, action) {
  switch (action.type) {
    case GET_HISTORY_REQUEST:
      return {
        ...state,
        isWaiting: true,
        error: initialState.error,
      };
    case GET_HISTORY_SUCCESS:
      return {
        ...state,
        payload: action.payload,
        isWaiting: false,
        error: initialState.error,
        lastRefresh: moment(),
      };
    case GET_HISTORY_FAILURE:
      return {
        ...state,
        error: action.error,
        isWaiting: false,
      };
    case GET_HISTORY_CACHED:
      return {
        ...state,
        isWaiting: false,
        error: initialState.error,
      };
    case SET_USER_IMPERSONATION:
      return { ...initialState };
    default:
      return state;
  }
}
